import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorCardComponent } from '@app/features/errors/components/error-card/error-card.component';
import { Cradlepoint } from '@app/shared/models/cradlepoint/cradlepoint.model';
import { CradlepointsService } from '../../shared/cradlepoints.service';

@Component({
    selector: 'app-cradlepoint-provisioning',
    templateUrl: './cradlepoint-provisioning.component.html',
    styleUrls: ['./cradlepoint-provisioning.component.scss'],
    standalone: false
})
export class CradlepointProvisioningComponent implements OnInit {
  
  storeNumberInput: string;
  macAddressInput: string;
  isLoading: boolean;
  hasSearched: boolean;
  newCradlepoint: Cradlepoint;
  configured: boolean;
  error: boolean;
  errorMessage: string;
  timedOut: boolean;
  isLoadingMain: boolean;
  prevStoreNumber: string;
  prevMacAddress: string;
  msp: string;
  
  constructor(private cradlepointsService: CradlepointsService, private dialog: MatDialog) { }

  ngOnInit() {
  }
 

  isStoreNumberInvalid() {
    const value = this.storeNumberInput ? this.storeNumberInput.toString() : '';
    return !/^\d{5}$/.test(value);
  }

  isMacAddressValid() {
    if (this.macAddressInput) {
      return this.macAddressInput.toString().length <= 17 && this.macAddressInput.toString().length >= 12;
    } 
    return false;
  }

  isSubmitDisabled() {
    return this.isStoreNumberInvalid() || !this.msp;
  }

  getRestaurantNetwork() {
    this.isLoading = true;
        this.resetView();
        Promise.all(
          [
            this.getCradlepoint()
          ]
        ).then(() => {
          this.isLoading = false;
          this.hasSearched = true;
        })
  }

  getCradlepoint() {
    const promise = new Promise((resolve, reject) => {
      this.cradlepointsService.findByMacAddress(this.macAddressInput).then(response => {
        response.toPromise().then(cradlepoints_from_response => {
          if (cradlepoints_from_response && cradlepoints_from_response["status"] == 200) {
            this.newCradlepoint = cradlepoints_from_response["message"];
          } else {
            this.dialog.open(ErrorCardComponent, { data: {
              message: this.extractErrorMessage(cradlepoints_from_response)
            }});
          }
          resolve(true);
        });
      });
    });
    

    return promise;
  }

  patchCradlepointConfig() {
    const promise = new Promise((resolve, reject) => {
      this.cradlepointsService.patchBuildConfig(this.newCradlepoint.mac, this.storeNumberInput.toString(), this.msp).then(response => {
        response.toPromise().then(patch_response => {
          if (patch_response && patch_response["status"] == 200) {
            this.configured = true;
          } else if (patch_response && patch_response["name"] == "TimeoutError") {
            this.timedOut = true;
            this.errorMessage = "The request did not come back in time. The change may still have been applied - check the router in NetCloud before retrying.";
          } else {
            this.error = true;
            this.errorMessage = this.extractErrorMessage(patch_response);
          }
          resolve(true);
        });
      })
    });
    return promise
  }

  /**
   * The observables funnel HttpErrorResponse, TimeoutError and successful
   * bodies down the same path, so the reason lives in a different place
   * depending on how the call failed.
   */
  private extractErrorMessage(response: any): string {
    if (!response) {
      return 'The request failed before it reached the API. Please try again.';
    }
    if (response.error && response.error.message) {
      return response.error.message;
    }
    if (typeof response.error === 'string' && response.error) {
      return response.error;
    }
    if (response.message) {
      return response.message;
    }
    return 'The request failed and the API did not give a reason.';
  }
  
  assignMsp(value) {
    this.msp = value;
  }
  

  submit() {
    this.isLoadingMain = true;
    this.configured = false;
    this.error = false;
    this.errorMessage = null;
    this.timedOut = false;
    console.log("Cradlepoint config is being updated");
    Promise.all(
      [
        this.patchCradlepointConfig()
      ]
    ).then(() => {
      this.getCradlepoint();
      this.isLoadingMain = false;
      this.prevStoreNumber = this.storeNumberInput;
      this.prevMacAddress = this.macAddressInput;
    })
    
    
    
  }

  resetView() {
    this.newCradlepoint = null;
    this.hasSearched = false;
    this.storeNumberInput = null;
    this.configured = false;
    this.error = false;
    this.errorMessage = null;
    this.timedOut = false;
    this.isLoadingMain = false;
    this.msp = null;
  }

}
